import {ELeadClientStatus} from 'src/containers/LeadCompanyClients';

export default {
  inviteLink: 'Ваша постоянная ссылка для регистрации клиентов',
  copyInviteLink: 'Скопировать',
  addContact: ' контакт',
  searchPlaceholder: 'быстрый поиск по клиенту',
  th: {
    createdAt: 'Дата регистрации',
    companyName: 'Название лида',
    status: 'Статус',
  },
  tab: 'Сводка',
  filters: {
    period: 'Выберите отчетный период',
    date: 'Дата регистрации',
    periodResult: 'Результат за период',
    contacts: 'Передано контактов',
    leads: 'Лидов создано',
    clients: 'Клиентов активировано',
    found: 'Клиентов',
    quarter: 'Квартал',
  },
  status: {
    [ELeadClientStatus.WAITING]: 'Лид',
    [ELeadClientStatus.REQUIRES_ATTENTION]: 'Лид',
    [ELeadClientStatus.DRAFT]: 'Контакт',
    [ELeadClientStatus.ACCEPTED]: 'Активный',
    [ELeadClientStatus.ERROR]: 'Отключен',
    [ELeadClientStatus.CANCELLED]: 'Просрочен',
  },
  createContact: {
    createTitle: 'Создать контакт',
    editTitle: 'Редактировать контакт',
    companyName: 'Название компании',
    contactName: 'Контактное лицо компании',
    phone: 'Телефон',
    email: 'email (необязательно)',
    comment: 'Комментарий (необязательно)',
  },
  successContactModal: {
    title: 'Контакт создан!',
    description:
      'С контактом продолжит работу менеджер edna. Анкета перейдет в статус Лид, когда менеджер свяжется с контактом и подберет для него коммерческие условия.',
    wellDone: 'Отлично',
  },
  allEmpty: {
    subtitle:
      'Пока у вас нет зарегистрированных клиентов, лидов или контактов. \n' +
      'Для начала создайте контакт и передайте его менеджеру edna',
  },
  clientStatus: 'Статус клиента:',
  contactCard: {
    companyInfo: 'Данные компании',
    companyName: 'Название юрлица:',
    contactName: 'Контактное лицо компании:',
    phone: 'Телефон:',
    email: 'email:',
    comment: 'Комментарий',
    edit: 'Редактировать данные',
  },
  leadCard: {
    responsibleManagerId: 'Ответственный менеджер edna',
    tariffsInfo: 'Тарифы',
  },
};
